let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dmnzB")).then(() => parcelRequire('4ltR1'));